/**
 * Returns the same thing as given
 *
 *     identity(1) === 1
 *     identity('Hello') === 'Hello'
 */
export function identity<T>(t: T): T {
    return t
}

/**
 * Also known as `const`.
 * Returns a function that always returns the same value.
 *
 *     const five = always(5)
 *     five(1) === 5
 *     five('Heelo', 'stranger', '!') === 5
 */
export function always<T>(value: T) {
    return (..._: unknown[]) => value
}

/**
 * Returns void and causing nothing to happen
 */
/* eslint-disable-next-line @typescript-eslint/no-empty-function */
export function doNothing() {}

/**
 * Returns Promise<void> and causing nothing to happen
 */
/* eslint-disable-next-line @typescript-eslint/no-empty-function */
export async function asyncDoNothing() {}

/**
 * Used to ignore any values given.
 * Useful for doing side effects in a catch eg
 *
 *     pipe(saveEntity(), promiseCatch(consoleLog, ignore))
 */
/* eslint-disable-next-line @typescript-eslint/no-empty-function */
export function ignore(..._: unknown[]) {}

/**
 * Used to cause a side effect without effecting the value in the pipe.
 *
 *    let message: string
 *    pipe(
 *        range(1, 10),
 *        find(n => n > 4),
 *        sideEffect(n => (message = `The number is ${n}`)),
 *        n => (isEven(n) ? 'Interesting...' : message),
 *        consoleLog
 *    )
 */
export function sideEffect<T1, T2>(fn: (t: T1) => T2) {
    return (t: T1) => {
        fn(t)
        return t
    }
}
